// orangish
export const START_POINT_COLOR = [255, 87, 34];

// blueish
export const POINT_COLOR = [41, 121, 255];

// greenish
export const BEST_PATH_COLOR = [76, 175, 80];

// orangish
export const EVALUATING_PATH_COLOR = [255, 87, 34, 225];

// reddish
export const EVALUATING_ERROR_COLOR = [255, 25, 25, 240];

// greyish
export const EVALUATING_SEGMENT_COLOR = [180, 180, 180, 240];

export const COLOR_MODE_KEY = "color-mode";
